$(function(){
	var considerList = $.cookie("considerList");
	if (!considerList) {
		considerList = new Array();
		$.cookie("considerList", considerList, {path:"/"});
	}
});

// 検討中リストに部屋を追加
addToConsiderList = function($element, options) {
	var roomId = $element.data("roomid");
	var considerList = $.cookie("considerList");

	if ($.inArray(roomId, considerList) == -1) {
		considerList.push(roomId);
	}
	
	$.cookie("considerList", considerList, {path:"/"});
	refreshConsiderCountView(considerList.length, options);
};

// 検討中リストから部屋を削除
removeFromConsiderList = function($td, options) {
	var roomId = $td.data("roomid");
	var considerList = $.cookie("considerList");
	
	$.each(considerList, function(i, val) {
		if (val==roomId) {
			considerList.splice(i,1); 
    	}
    });
    
    $.cookie("considerList", considerList, {path:"/"});
	refreshConsiderCountView(considerList.length, options);
};

// 検討中リスト件数表示を更新
refreshConsiderCountView = function(considerCount, options) {
	options = options||{};
	var selector, afterText;
	if (!options.isSp) {
		selector = ".review_num";
	} else {
		selector = ".review_num";
	}
	var reviewNum = $(selector);
	if (reviewNum.length > 0) {
		$(selector).text(considerCount);
	}
}

// 初期処理
$(function() {
	refreshConsiderCountView(
		$.cookie("considerList").length,
		{ isSp: Boolean( location.pathname.match(/^\/sp\//) ) }
	);
});

// ヘッダーフッターに検討中カウントを追加
$(function() {
	var count = $.cookie("considerList").length
	console.log(count)
	if(count !== 0) {
		$('.review_num').append(count[0]);
	} else {
		$('.review_num').empty();
	}
	$('.addreview').on('click',function() {
		if($('.review_num').text() < 1) {
			$('.review_num').empty();
		}
	})
})